import { gql } from "@apollo/client";
import { useEffect } from "react";
import { FaArrowRightArrowLeft, FaArrowRightLong } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import ".././AddVendorAccount.scss";
import Button from "../../../Button/Button";

export const GET_VEHICLE_CATEGORY_OF_USER = gql`
  query GetAllVehicleCategoryManagement($AccountID: ID) {
    getAllVehicleCategoryManagement(AccountID: $AccountID) {
      _id
      Unique_Id
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_VEHICLE_TYPE = gql`
  query SearchVehicleTypeMasters($keyword: String) {
    searchVehicleTypeMasters(keyword: $keyword) {
      _id

      Search_Value
    }
  }
`;

export const GET_VEHICLE_CATEGORY = gql`
  query SearchVehicleCategory_With_VechileMasters($keyword: String!, $vehicleTypeId: ID) {
    searchVehicleCategory_With_VechileMasters(keyword: $keyword, Vehicle_Type_Id: $vehicleTypeId) {
      _id
      Unique_Id
      Name
      Search_Value
      Vehicle_Type
      User_ID
      createdAt
      updatedAt
    }
  }
`;
interface dataType {
  From_Location: string;
  From_Type: string;
  To_Location: string;
  To_Type: string;
  Is_Reverse: boolean;
}

const SelectedLanes = ({ setformatedData, formatedData }) => {
  // const [FormatedData, setFormatedData] = useState<dataType[] | Array<undefined>>(formatedData);
  useEffect(() => {
    setformatedData(formatedData);
  }, [formatedData]);

  const handleLineCheck = (i, check) => {
    let updatedData = formatedData?.map((el, index) => {
      if (i === index) {
        return { ...el, Is_Reverse: check };
      }
      return el;
    });
    setformatedData(updatedData);
  };

  const handleDeleteLane = (indexToRemove: number) => {
    // Filter out the element at index `i` and refine the type to exclude `undefined`.
    const updatedData = formatedData?.filter((el, index): el is dataType => {
      return index !== indexToRemove;
    });

    setformatedData(updatedData); // This should work without type errors.
  };

  const handleDeleteAll = () => {
    setformatedData([]);
  };

  return (
    <div className="firstcontainer">
      <div>
        <p className="headings">Selected Data</p>
      </div>
      {formatedData?.length === 0 ? (
        <div className="no-data-message">No data available</div>
      ) : (
        <div className="lane-cards">
          <div className="">
            <div className="DeleteAllContainer">
              <Button action={handleDeleteAll} name="modalbutton" text="Delete All" />
            </div>
            {formatedData?.map((lane, i) => (
              <div key={lane?._id} className="lanecard">
                <div className="lanesegment">
                  <span className="location">{lane?.From_Location}</span>
                </div>
                {lane?.Is_Reverse === false ? (
                  <FaArrowRightLong className="reverse-symbol" />
                ) : (
                  <FaArrowRightArrowLeft className="reverse-symbol" />
                )}

                <div className="lanesegment">
                  <span className="location">{lane?.To_Location}</span>
                </div>
                <div>
                  <input
                    type="checkbox"
                    checked={lane?.Is_Reverse}
                    onChange={(e) => handleLineCheck(i, e.target.checked)}
                  />
                </div>
                <div>
                  <MdDelete className="delete-box" onClick={() => handleDeleteLane(i)} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectedLanes;
